module.exports = __webpack_public_path__ + "static/media/lowercase.10fa0985.svg";